<script setup lang="ts">
    import { Input } from '@/components/ui/input';
    import type { HTMLAttributes } from 'vue';

    defineProps<{
        placeholder?: string;
        class?: HTMLAttributes['class'];
    }>();

    const model = defineModel<string | null>();

    const formatCreditCardNumber = (event: Event) => {
        const target = event.target as HTMLInputElement;
        let value = target.value.replace(/\s/g, ''); // Remove all spaces
        value = value.replace(/[^\d*]/g, ''); // Allow digits and * characters only
        value = value.substring(0, 19); // Limit to 16 characters (excluding spaces)

        // Add space after every 4 characters (digits or *)
        const formatted = value.replace(/([0-9*]{4})(?=[0-9*])/g, '$1 ');

        // Update both the input value and the form data
        target.value = formatted;
        value = formatted;
    };
</script>

<template>
    <Input
        id="number"
        v-model="model"
        maxlength="19"
        placeholder="1234 1234 1234 1234"
        @input="formatCreditCardNumber"
    />
</template>
